import { useSearchParams } from '@remix-run/react';
import { useMemo } from 'react';
import { createCheckoutSessionRequestSchema } from '@medizzy/payments';

export function useActivePromo() {
  const [searchParams] = useSearchParams();
  const promo = useMemo(() => {
    const param = searchParams.get('promo');
    const validation =
      createCheckoutSessionRequestSchema.shape.variant.safeParse(param);

    if (validation.success) {
      return validation.data;
    }

    return null;
  }, [searchParams.get]);

  return { promo };
}
